/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'access': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M160 320H64v640h640v-96H160zM864 64H320v96h544v544h96V64z"/><path pid="1" d="M256 768h512V256H256v512zm96-304h320v96H352v-96z"/>'
  }
})
